import { Component, Input, OnInit } from '@angular/core';
import { EnvironmentService } from 'src/app/service/environment.service';

declare const window: any;
@Component({
  selector: 'instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss'],
  standalone: false,
})
export class InstagramComponent implements OnInit {
  @Input() _uid!: string;

  @Input() component!: string;

  @Input() _editable: any;

  constructor(private environmentService: EnvironmentService) {}

  ngOnInit(): void {
    if (this.environmentService.isBrowser()) {
      if (window.instafeedApp) {
        window.instafeedApp();
      }
    }
  }
}
